// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"6b991bf9","198":"db5d1e94","542":"14ca5139","960":"df6b8f17"}[chunkId] + ".chunk.css";
};